import React, { useState } from 'react'
import PropTypes from 'prop-types'

// Api
import { downloadDocument, downloadEcwt } from 'api/ecwt'

// Model
import Ecwt from 'models/Ecwt'

// Components
import Button from 'ui/Button'
import Text from 'ui/Text'

export const ColumnAction = ({ row }) => {
  const [loading, setLoading] = useState(false)

  const onDownloadAll = async () => {
    try {
      setLoading(true)
      await Promise.all([
        downloadEcwt(row.fileName),
        downloadDocument(row.fileName),
      ])
    } catch (error) {
      //
    } finally {
      setLoading(false)
    }
  }
  return (
    <>
      {row.isVoid || !row.isAcknowledge ? (
        <Text
          style={{
            cursor: 'not-allowed',
            color: '#C0C4CC',
            textDecoration: 'underline',
          }}
        >
          Download
        </Text>
      ) : (
        <Button
          underline
          variant="link"
          loading={loading}
          onClick={onDownloadAll}
        >
          Download
        </Button>
      )}
    </>
  )
}

ColumnAction.propTypes = {
  row: PropTypes.instanceOf(Ecwt),
}

ColumnAction.defaultProps = {
  row: new Ecwt(),
}

export default ColumnAction
